/**
 * Multiselect dropdown options for arbitrage decision failure-reason filters.
 * Shared by sport-level and event-level decisions pages.
 */
export interface ArbitrageDecisionDropdownOption {
  item_id: string;
  item_text: string;
}

export const ARBITRAGE_DECISION_FAILURE_REASON_OPTIONS: ArbitrageDecisionDropdownOption[] = [
  { item_id: "MARKET_RISK_CHECK_FAILED", item_text: "MARKET_RISK_CHECK_FAILED" },
  { item_id: "MARKET_RISK_CHECK_ERROR", item_text: "MARKET_RISK_CHECK_ERROR" },
  { item_id: "LOCK_ACQUISITION_FAILED", item_text: "LOCK_ACQUISITION_FAILED" },
  { item_id: "SR_BET_PLACEMENT_FAILED", item_text: "SR_BET_PLACEMENT_FAILED" },
  { item_id: "SR_BET_STATUS_CHECK_FAILED", item_text: "SR_BET_STATUS_CHECK_FAILED" },
  { item_id: "BF_BET_PLACEMENT_FAILED", item_text: "BF_BET_PLACEMENT_FAILED" },
  { item_id: "BF_BET_STATUS_CHECK_FAILED", item_text: "BF_BET_STATUS_CHECK_FAILED" },
  { item_id: "BF_BET_RETRY_EXHAUSTED", item_text: "BF_BET_RETRY_EXHAUSTED" },
  { item_id: "BF_BET_RETRY_SELECTION_FAILED", item_text: "BF_BET_RETRY_SELECTION_FAILED" },
  { item_id: "BF_BET_RETRY_LOSS_MAKING", item_text: "BF_BET_RETRY_LOSS_MAKING" },
  { item_id: "BF_ODD_VOLUME_BELOW_THRESHOLD", item_text: "BF_ODD_VOLUME_BELOW_THRESHOLD" },
  { item_id: "MAX_BETS_EXCEEDED", item_text: "MAX_BETS_EXCEEDED" },
  { item_id: "ARBITRAGE_DISABLED", item_text: "ARBITRAGE_DISABLED" },
  { item_id: "MARKETBOOK_DISABLED", item_text: "MARKETBOOK_DISABLED" },
  { item_id: "MARKET_NOT_ACTIVE", item_text: "MARKET_NOT_ACTIVE" },
  { item_id: "NO_MARGIN_REBALANCE_SELECTION_FAILED", item_text: "NO_MARGIN_REBALANCE_SELECTION_FAILED" },
  { item_id: "NO_MARGIN_SR_STAKE_NOT_FOUND", item_text: "NO_MARGIN_SR_STAKE_NOT_FOUND" },
  { item_id: "NO_MARGIN_COMBINED_BELOW_BASELINE_MIN", item_text: "NO_MARGIN_COMBINED_BELOW_BASELINE_MIN" },
];

export const ARBITRAGE_DECISION_NO_MARGIN_CASE_OPTIONS: ArbitrageDecisionDropdownOption[] = [
  { item_id: "PRESERVE_PROFIT_ZERO_RISK", item_text: "PRESERVE_PROFIT_ZERO_RISK" },
  { item_id: "PRESERVE_PROFIT_REDUCE_RISK", item_text: "PRESERVE_PROFIT_REDUCE_RISK" },
  { item_id: "PRESERVE_PROFIT_NEGATIVE_RISK", item_text: "PRESERVE_PROFIT_NEGATIVE_RISK" },
  { item_id: "REDUCE_PROFIT_ZERO_RISK", item_text: "REDUCE_PROFIT_ZERO_RISK" },
  { item_id: "REDUCE_PROFIT_REDUCE_RISK", item_text: "REDUCE_PROFIT_REDUCE_RISK" },
];

// Market names used by arbitrage decision/report UIs.
export const ARBITRAGE_COMMON_MARKETS = {
  matchOdds: "Match Odds",
};

// Each sport list should include Match Odds (common market).
export const ARBITRAGE_MARKET_NAMES_BY_SPORT: { [sportId: string]: string[] } = {
  // Soccer
  "1": [
    ARBITRAGE_COMMON_MARKETS.matchOdds,
    "Over/Under 0.5 Goals",
    "Over/Under 1.5 Goals",
    "Over/Under 2.5 Goals",
  ],
  // Tennis
  "2": [ARBITRAGE_COMMON_MARKETS.matchOdds, "Set 1 Winner", "Set 2 Winner"],
  // Basketball
  "7522": [ARBITRAGE_COMMON_MARKETS.matchOdds, "Moneyline"],
};